<template>
  <div>
    <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls">
      <h3>{{$t('form.tender.overview-tender-details')}}</h3>
    </div>
    <div class="admin__a-tab-content admin__a-tab-content--show">
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-number')}}:</div>
        <p class="a-input a-input--disabled">{{tender.num}}</p>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-name')}}:</div>
        <p class="a-input a-input--disabled">{{tender.name}}</p>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-publish-date')}}:</div>
        <date-time class="a-input a-input--disabled" :value="tender.publicationDate"></date-time>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-publish-changes-datetime')}}:</div>
        <date-time class="a-input a-input--disabled" :value="tender.lastChangeDate"></date-time>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.customer')}}:</div>
        <p class="a-input a-input--disabled">{{customerTitle}}</p>
      </div>
      <div class="a-container-form">
        <div class="a-label a-label--w-280">{{$t('form.tender.initiator-contact-details')}}:</div>
        <p class="a-input a-input--disabled">
          {{tender | fullName}}
          <br> {{tender.email}}
          <br> {{tender.phone}}
        </p>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.tender-method')}}:</div>
        <p class="a-input a-input--disabled">{{$t(tender.method.label)}}</p>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.tender.participation-mode')}}:</div>
        <p class="a-input a-input--disabled">{{$t(tender.participationMode.label)}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tender: Object
    }
  }
</script>

<style scoped>

</style>
